import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmazePlayerComponent } from './amaze-player.component';

@NgModule({
  declarations: [AmazePlayerComponent],
  imports: [CommonModule],
  exports: [AmazePlayerComponent],
})
export class AmazePlayerModule {}
